import React from 'react';
import PortfolioReview from './PortfolioReview';

function App() {
  return (
    <PortfolioReview />
  );
}

export default App;